var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"project-wrap"},[_vm._ssrNode("<div class=\"project\" data-v-d07425a4><div class=\"flex btn-nav\""+(_vm._ssrStyle(null,null, { display: (false) ? '' : 'none' }))+" data-v-d07425a4><img"+(_vm._ssrAttr("src",require("@/assets/img/builder.png")))+" data-v-d07425a4><span data-v-d07425a4>Product builder</span></div></div>")])
}
var staticRenderFns = []

export { render, staticRenderFns }